import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import ResponsiveAppBar from "./Appbar";
import Footer from "./Footer";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import GoogleIcon from '@mui/icons-material/Google';

// Template for the website
const Template = ({children}) => {

    return (
        <Box display="flex" flexDirection="column" minHeight="100vh">
      <Container>
        <Grid container>            
          <Grid item xs={12}>
            <ResponsiveAppBar />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid container xs={12} alignItems={'center'} sx={{               
            paddingBottom: '15px',
            backgroundColor: '#fafafa',
            paddingLeft: {xs: 0, sm: '15px'},
            textAlign: {xs: 'center', sm: 'inherit'},
            mt: 2
        }}>
            <Grid item sm={'auto'} xs={12} sx={{
                pr: {xs: 0, sm: 2},
                mt: 3,                                            
                }}>
                <img src="profile.jpg" alt="Javad Mokhtari Koushyar" width={"200px"} style={{borderRadius: '50%', minWidth: '200px', minHeight: '200px', border: '1px solid black'}} />
            </Grid>
            <Grid item container xs>
                <Grid item xs={12}>
                    <Typography variant='body1' fontWeight={'bold'} sx={{color: '#ff0033', textAlign: {xs: 'center', sm: 'inherit'}}}>Javad Mokhtari Koushyar</Typography>
                </Grid>
                <Grid item xs={12} sx={{mb: 3}}>
                    <Typography variant='overline'>Ph.D. Student of Computer Science at <a rel='noreferrer' target='_blank' href="https://www.txst.edu/">TXST</a></Typography>
                </Grid>
                <Grid item container xs={12} sx={{mb: .5}}>
                    <Grid item sm={2} xs={12}>
                        <Typography style={{fontWeight: 'bold'}}>Email</Typography>
                    </Grid>
                    <Grid item xs={'auto'} sx={{margin: {xs: 'auto', sm: 'inherit'}}}>
                        <Typography style={{fontStyle: 'italic'}}><b>koushyar</b> AT <b>txstate</b> DOT <b>edu</b></Typography>
                    </Grid>
                </Grid>   
                {/* <Grid item container xs={12}>
                    <Grid item sm={2} xs={12}>
                        <Typography style={{fontWeight: 'bold'}}>Phone</Typography>
                    </Grid>
                    <Grid item xs={'auto'}>
                        <Typography style={{fontStyle: 'italic'}}>512-423-5676</Typography>
                    </Grid>
                </Grid>    */}
                <Grid item container xs={12} sx={{mb: .5}}>
                    <Grid item sm={2} xs={12}>
                        <Typography style={{fontWeight: 'bold'}}>Address</Typography>
                    </Grid>
                    <Grid item xs={'auto'} sx={{margin: {xs: 'auto', sm: 'inherit'}}}>
                        <Typography style={{fontStyle: 'italic'}}>Texas, United States</Typography>
                    </Grid>
                </Grid>                
                <Grid item container xs={12}>
                    <Grid item sm={2} xs={12}>
                        <Typography style={{fontWeight: 'bold'}}>Social Media</Typography>
                    </Grid>
                    <Grid item xs={'auto'} sx={{margin: {xs: 'auto', sm: 'inherit'}}}>
                        <Typography style={{fontStyle: 'italic', '& a': {color:'blue', textDecoration: 'none'}}}>
                            <a style={{marginRight: '13px'}} rel="noreferrer" target="_blank" href='https://scholar.google.com/citations?user=gNSzFdMAAAAJ&hl=en&oi=ao'><GoogleIcon color="success" /></a>                         
                            <a style={{marginRight: '13px'}} rel="noreferrer" target="_blank" href='https://www.linkedin.com/in/javad-mokhtari/'><LinkedInIcon color="secondary" /></a>
                            <a rel="noreferrer" target="_blank" href='https://github.com/j0m0k0/'><GitHubIcon color="primary" /></a>                            
                        </Typography>
                    </Grid>
                </Grid>                
            </Grid>
        </Grid>
        
          <Grid item container xs={12} sx={{ mt: 2 }}>
            {children}
          </Grid>
        </Grid>
      </Container>
      <Box flexGrow={1} />
      <Box>
        <Footer />
      </Box>
    </Box>
    );
}

export default Template;
